// The permission matrix module list is now sourced from the module registry
// via GET /roles/permission-modules (see usePermissionModules). These types
// describe that response; children are grouped under their parent section.
export type PermissionMatrixModule = {
  module: string;
  label: string;
  sortOrder: number;
};

export type PermissionMatrixGroup = {
  name: string | null;
  label: string | null;
  sortOrder: number;
  modules: PermissionMatrixModule[];
};

export const MODULE_LABELS: Record<string, string> = {
  companies: "Companies",
  partners: "Partners",
  finance_accounts: "Accounts",
  finance_income: "Income",
  finance_contributions: "Contributions",
  products: "Products",
  projects: "Projects",
  budgets: "Budgets",
  expenses: "Expenses",
  meetings: "Meetings",
  tasks: "Tasks",
  actions: "Actions",
  notes: "Notes",
  ideas: "Ideas",
  decisions: "Decisions",
  milestones: "Milestones",
  access_vault: "Access Vault",
  user_management: "User Management",
  role_management: "Role Management",
  module_manager: "Module Manager",
  dropdown_manager: "Dropdown Manager",
  audit_center: "Audit Center",
};

export function moduleLabel(module: string): string {
  return (
    MODULE_LABELS[module] ??
    module
      .split("_")
      .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
      .join(" ")
  );
}

export type RolePermission = {
  module: string;
  canView: boolean;
  canCreate: boolean;
  canEdit: boolean;
  canDelete: boolean;
  canExport: boolean;
  canAdmin: boolean;
};

export const PERMISSION_KEYS = [
  "canView",
  "canCreate",
  "canEdit",
  "canDelete",
  "canExport",
  "canAdmin",
] as const;
export type PermissionKey = (typeof PERMISSION_KEYS)[number];

export const PERMISSION_LABELS: Record<PermissionKey, string> = {
  canView: "View",
  canCreate: "Create",
  canEdit: "Edit",
  canDelete: "Delete",
  canExport: "Export",
  canAdmin: "Admin",
};

export type RoleListItem = {
  id: string;
  name: string;
  description: string | null;
  isSystem: boolean;
  isActive: boolean;
  userCount: number;
  createdAt: string;
  updatedAt: string;
};

export type RoleDetail = RoleListItem & {
  permissions: RolePermission[];
};

export type CreateRolePayload = {
  name: string;
  description?: string | null;
  isActive?: boolean;
  copyFromRoleId?: string | null;
};

export type UpdateRolePayload = {
  name?: string;
  description?: string | null;
  isActive?: boolean;
};
